<a href="{{firendsUrl}}">
<div class="friend-banner">
  <div class="friend-content" >
    <span i18n="@@frindbanner.title">High 5!</span>
    <div class="friend-body">
      <span i18n="@@frindbanner.subtitle">Recommend us to a friend.<br/>Get 5 credits each.</span>
    </div>
  </div>
</div>
</a>